import * as actionTypes from "./action-types";

export const setPivotState = (pageState) => {
    
    return {
        type: actionTypes.SET_PIVOT_STATE,
        ...pageState
    }
}